// ABOUTME: Renders a feeling's hand-drawn SVG face (brows/eyes/mouth) -- ported from the prototype's
// ABOUTME: per-feeling path data, not a colored-circle placeholder (Issue #1945, S25 mockup gap).

import { FEELING_FACES } from '../../../theme/feelingFaces';
import { CROSSING_FACE_FILL, CROSSING_FACE_STROKE } from '../../../theme/crossingTokens';

interface FeelingFaceIconProps {
  code: string;
  hue: string;
  size?: number;
}

export default function FeelingFaceIcon({ code, hue, size = 64 }: FeelingFaceIconProps) {
  const face = FEELING_FACES[code];

  return (
    <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden focusable="false">
      <circle cx={32} cy={32} r={28} fill={CROSSING_FACE_FILL} stroke={hue} strokeWidth={4} />
      {face && (
        <>
          <path d={face.brows} stroke={CROSSING_FACE_STROKE} strokeWidth={3} fill="none" strokeLinecap="round" />
          <path d={face.eyeSleepy} stroke={CROSSING_FACE_STROKE} strokeWidth={3} fill="none" strokeLinecap="round" />
          <path d={face.eyeFull} fill={CROSSING_FACE_STROKE} stroke="none" />
          <path d={face.mouth} stroke={CROSSING_FACE_STROKE} strokeWidth={3} fill="none" strokeLinecap="round" />
          <path d={face.mouthFull} fill={CROSSING_FACE_STROKE} stroke="none" />
          <path d={face.extra} stroke={CROSSING_FACE_STROKE} strokeWidth={2.2} fill="none" strokeLinecap="round" />
        </>
      )}
    </svg>
  );
}
